import axios from 'axios';

import { parameters } from '../../constants/parameters';

export interface Country {
  id: number;
  code: string;
  name: string;
}

export const list = async (token: string): Promise<Country[]> => {
  const url = `${parameters.api.baseUrl}/countries`;

  const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });

  return res.data;
};
